module.exports = __webpack_public_path__ + "static/media/aicu.2333f38a.jpg";